// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2HGXD","header":"MergedInvoice_header__1T63d"};